import { css } from '@emotion/react'
import clsx from 'clsx'
import { ModalProps } from './types'

const CLASSNAME_PREFIX = 'jk-modal'
export interface ModalContentProps
	extends Pick<ModalProps, 'title' | 'footer' | 'header' | 'children' | 'isShow'> {}

export default function ModalContent({
	title,
	footer,
	header,
	children,
	isShow,
	...props
}: ModalContentProps) {
	return (
		<div
			className={clsx(`${CLASSNAME_PREFIX}-container`, {
				show: isShow,
			})}
			css={css`
				display: grid;
				grid-template-rows: ${header ? 'auto' : ''} 1fr;
			`}
		>
			{header && (
				<div
					className={`${CLASSNAME_PREFIX}-header`}
					css={css`
						display: flex;
						align-items: center;
						padding: 16px;

						> * {
							flex: 1;
							display: flex;
							align-items: center;
						}
					`}
				>
					{header}
				</div>
			)}
			<main
				css={css`
					overflow: hidden;
					display: grid;
					grid-template-rows: auto 1fr ${footer ? 'auto' : ''};
					padding: ${header ? '0' : '20px'} 20px 20px;
				`}
				className={`${CLASSNAME_PREFIX}-main`}
			>
				{title && (
					<h6
						css={css`
							font-weight: 500;
							font-size: 18px;
							line-height: 28px;
							text-align: center;
							color: var(--tint-primary);
							margin: 0 auto 8px;
						`}
						className={`${CLASSNAME_PREFIX}-title`}
					>
						{title}
					</h6>
				)}

				{children && (
					<div
						css={css`
							font-size: 14px;
							line-height: 22px;
							color: var(--tint-secondary);
							overflow: hidden;
							overflow-y: auto;
							margin-right: -10px;
							padding-right: 10px;
						`}
						className={`${CLASSNAME_PREFIX}-content`}
					>
						{children}
					</div>
				)}

				{footer && (
					<div
						className={`${CLASSNAME_PREFIX}-footer`}
						css={css`
							margin-top: 12px;
							display: flex;
							justify-content: center;
							align-items: center;

							& > *:not(:first-of-type) {
								margin-left: 10px;
							}
						`}
					>
						{footer}
					</div>
				)}
			</main>
		</div>
	)
}
